// ControlList.js
import React from 'react';
import BasicControlOption from "components/BasicControlOption/BasicControlOption";
import CourseMapOptionList from "components/CourseMapOptionList/CourseMapOptionList";
import styles from "styles/pages/Map1.module.scss";
import stylesRightList from "styles/component/RightList.module.scss";

const MapControlList = ({ BasicControls, mapControlList, cancelEdit, hazardData, fcbData, teeCenterData,courseWiseData,clubHouseCenterData, isMapControlListPanelHidden, setMapControlListPanelHidden }) => {
  // ... Control list rendering logic goes here
 
  return (
    <div className={styles.right_list}>
      <div className={stylesRightList.side_list}>
        <ul>
          {BasicControls.map((data, index) => (
            <li key={data?.title + index}>
              <BasicControlOption
                index={index}
                icon={data?.icon}
                isIcon={data?.isIcon}
                title={data?.title}
                onClickEvent={data?.callBack}
                isActive={data?.isActive}
                tooltipText={data?.tooltipText}
              />
            </li>
          ))}
        </ul>
        <ul>
          {mapControlList?.map((data, index) => (
            <li key={data?.title + index}>
              <CourseMapOptionList
                tooltipText={data?.tooltipText}
                index={index}
                icon={data?.icon}
                isIcon={data?.isIcon}
                title={data?.title}
                optionListStyleTwo={data?.optionListStyleTwo}
                noTable={data?.noTable}
                data={data?.data}
                hazardData={hazardData}
                fcbData={fcbData}
                teeCenterData={teeCenterData}
                cancelEdit={cancelEdit}
                courseWiseData={courseWiseData}
                clubHouseCenterData={clubHouseCenterData}
                isMapControlListPanelHidden={isMapControlListPanelHidden}
                setMapControlListPanelHidden={setMapControlListPanelHidden}
              />
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}

export default MapControlList;
